document.addEventListener('DOMContentLoaded', () => {

  const buttons = document.querySelectorAll('.ce-btn');
  const groups = document.querySelectorAll('.ce-group');

  function show(menu){

    groups.forEach(group=>{
      group.classList.remove('active');
    });

    buttons.forEach(button=>{
      button.classList.remove('active');
    });

    document
      .querySelector(`.ce-group[data-group="${menu}"]`)
      ?.classList.add('active');

    document
      .querySelector(`.ce-btn[data-menu="${menu}"]`)
      ?.classList.add('active');

  }

  buttons.forEach(button=>{

    button.addEventListener('click',()=>{

      show(button.dataset.menu);

    });

  });

  // No mostrar ningún grupo al cargar

});